import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function AccountSettingSidebar() {
  const location = useLocation();
  console.log("location", location);
  return (
    <div className="nested-menu">
      <div className="menu-title">
        <p>General</p>
      </div>
      <div className="menu-items">
        <ul>
          <li>
            <Link to="/admin/settings/profile" className={location.pathname.includes("/profile") ? "active" : ""}>
              Account settings
            </Link>
          </li>
          {/* <li>
            <Link to="/admin/settings/widgets" className={location.pathname.includes("/widget") ? "active" : ""}>
              Widgets
            </Link>
          </li> */}
          {/* <li>
                        <Link to="/admin/settings/notification">Notifications</Link>
                    </li> */}
        </ul>
      </div>
      
      {(window.modulePermissions.M3.view === 1 || window.modulePermissions.M4.view === 1 || window.modulePermissions.M5.view === 1) && (
        <>
          <div className="menu-title">
            <p>User management</p>
          </div>
          <div className="menu-items">
            <ul>
              {window.modulePermissions.M3.view === 1 && (
                <li>
                  <Link to="/admin/settings/user-permissions" className={location.pathname.includes("/settings/user-permissions") ? "active" : ""}>Users</Link>
                </li>
              )}
              {window.modulePermissions.M4.view === 1 && (
                <li>
                  <Link to="/admin/settings/user-roles" className={location.pathname.includes("/settings/user-roles") ? "active" : ""}>Roles</Link>
                </li>
              )}
              {window.modulePermissions.M5.view === 1 && (
                <li>
                  <Link to="/admin/settings/teams/list" className={location.pathname.includes("/settings/teams/list") ? "active" : ""}>Teams</Link>
                </li>
              )}
            </ul>
          </div>
        </>
      )}
    </div>
    
  );
}
